import { ActionType } from '../reducers/header';
import { api } from '../config';
import mockData from '../mocks/header.json';

import { isUrlCached, getUrlCache } from '../utils/cache';

export const getHeaderData = () => {
  return (dispatch) => {
    const shouldFetchMock = false;
    const fetchType = shouldFetchMock ? 'FETCH_MOCK' : 'FETCH';
    const mockResult = mockData;

    const url = `${api.header}`;
    const method = 'get';
    const headers = {};
    const options = {
      cache: true,
    };

    const cacheUrl = `${url}`;
    if (isUrlCached(cacheUrl)) {
      const urlCache = getUrlCache(cacheUrl);
      if (urlCache.data) {
        return dispatch({
          type: 'IS_CACHED_HEADER_DATA',
          payload: urlCache.data,
        });
      }
    }

    const type: ActionType = 'SET_HEADER_DATA';
    return Promise.resolve(
      dispatch({
        type,
        fetch: {
          type: fetchType,
          actionTypes: {
            request: 'REQUEST_HEADER_DATA',
            success: 'RECEIVED_HEADER_DATA',
            fail: 'ERROR_HEADER_DATA',
          },
          url,
          // props only used when type = FETCH_MOCK:
          mockResult,
          method,
          headers,
          options,
        },
      }),
    );
  };
};
